import { connect } from 'react-redux';
import View from './AssumptionsView';
import { initializeSection, requestData, resetSection } from './AssumptionsActions';
import { assumptionsSelector, correlationMatrixSelector } from './AssumptionsSelector';
import {
  isAdviserArea,
  currentClientIdSelector,
  selectPortalName,
} from '../CommonSelectors/CommonAreaSelector';

const mapStateToProps = state => ({
  assumptions: assumptionsSelector(state),
  correlationMatrix: correlationMatrixSelector(state),
  isAdviserArea: isAdviserArea(state),
  clientId: currentClientIdSelector(state),
  portalName: selectPortalName(state),
});

const mapDispatchToProps = {
  initializeSection,
  requestData,
  resetSection,
};

export default connect(mapStateToProps, mapDispatchToProps)(View);
